import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { APIResponse } from '../_types/api-responses.types';
import {
  GetCentralisationCompaniesRequest,
  GetCentralisationCompaniesResponse,
} from '../_types/centralisation.types';
import {
  CategoryDocument,
  GetCompanyContactsResponse,
} from '../_types/product.types';
import { Globals } from '../globals';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  _headers: HttpHeaders;

  _baseURL: any;

  user: any;

  deviceId: number;

  constructor(
    private httpClient: HttpClient,
    private globaols: Globals
  ) {
    this.deviceId = Date.now();
    this.user = this.globaols.getUser();
    this._headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('content-type', 'application/json')
      .set('partner-id', this.user.partnerId)
      .set('Access-Token', this.user.token);
    this._baseURL = environment.apiUrl;
  }

  get headers() {
    return this._headers.set('Access-Token', this.globaols.getUser().token);
  }

  /**
   * Every insurance company with the addresses it publishes, for the "Email
   * compagnie" picker.
   *
   * `searchBy` is left out on purpose: the server matches it against the English
   * `category` column only, accent-sensitively, and orders by creation date — so
   * the whole list is fetched once and filtered client-side instead.
   */
  getCompanyContacts(): Observable<APIResponse<GetCompanyContactsResponse>> {
    return this.httpClient.post<APIResponse<GetCompanyContactsResponse>>(
      `${this._baseURL}api/catalogue/v1/category/get/company-contacts`,
      {},
      { headers: this.headers }
    );
  }

  _addProduct(obj: any): Observable<any> {
    return this.httpClient.post(
      `${this._baseURL}api/catalogue/v1/product/add`,
      obj,
      { headers: this.headers }
    );
  }

  _updateProduct(obj: any): Observable<any> {
    return this.httpClient.put(
      `${this._baseURL}api/catalogue/v1/product/update`,
      obj,
      { headers: this.headers }
    );
  }

  _listAllProduct(obj: any): Observable<any> {
    return this.httpClient.post(
      `${this._baseURL}api/catalogue/v1/product/get/category`,
      obj,
      { headers: this.headers }
    );
  }

  _deleteProduct(obj: any): Observable<any> {
    return this.httpClient.post(
      `${this._baseURL}api/catalogue/v1/product/delete`,
      obj,
      { headers: this.headers }
    );
  }

  getCategoryDocuments(
    categoryId: string,
    activeOnly: boolean = false
  ): Observable<APIResponse<{ documents: CategoryDocument[] }>> {
    return this.httpClient.post<APIResponse<{ documents: CategoryDocument[] }>>(
      `${this._baseURL}api/catalogue/v1/category-condition-document/get`,
      { categoryId, activeOnly },
      { headers: this.headers }
    );
  }

  getCentralisationCompanies(
    obj: GetCentralisationCompaniesRequest
  ): Observable<APIResponse<GetCentralisationCompaniesResponse>> {
    return this.httpClient.post<
      APIResponse<GetCentralisationCompaniesResponse>
    >(
      `${this._baseURL}api/catalogue/v1/category/get/centralisation-companies`,
      obj,
      { headers: this.headers }
    );
  }
}
